import { ProfileUserInfoItem } from '../../../../Widget'

import { RequestProfileWidgetProvidersRecommendedProviderAddButton } from './RequestProfileWidgetProvidersRecommendedProviderAddButton'

import * as styles from './RequestProfileWidgetProvidersRecommendedProviderItem.module.css'

import ProviderIcon from '../../../../../icons/provider.svg'

function RequestProfileWidgetProvidersRecommendedProviderItem({
  canAdd = true,
  isDisabled,
  value,
  onAdd,
}) {
  return (
    <div className={styles.item}>
      <div className={styles.provider}>
        <ProfileUserInfoItem Icon={ProviderIcon} value={value} />
      </div>
      {canAdd ? (
        <RequestProfileWidgetProvidersRecommendedProviderAddButton
          isDisabled={isDisabled}
          itemId={value?.id}
          onClick={onAdd}
        />
      ) : null}
    </div>
  )
}

export default RequestProfileWidgetProvidersRecommendedProviderItem
